import { styled } from "styled-components";

export const CallRatesResultsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 48px 24px 96px 24px;
`;

export const CallRatesResultsContainer = styled.div`
  height: 100%;
  width: 100%;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 24px;

  ${({ theme }) => theme.breakpoints.md.query} {
    justify-content: center;
  }
`;

export const Alert = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  height: 48px;
  background: transparent;
  bottom: 0;
  left: 0;
  color: ${({ theme }) => theme.colors.primary.default};
`;

export const CallRateSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  & > h6 {
    color: ${({ theme }) => theme.colors.primary.default};
    align-self: flex-start;
  }

  ${({ theme }) => theme.breakpoints.md.query} {
    width: 100%;
  }
`;

export const CallRateCard = styled.div`
  display: flex;

  padding: 24px;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 12px;
  width: 600px;

  background: ${({ theme }) => theme.colors.default[50]};
  ${({ theme }) => theme.breakpoints.md.query} {
    width: 100%;
  }
`;

export const CallRateCardSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  width: 50%;

  ${({ theme }) => theme.breakpoints.md.query} {
    width: 100%;
  }
`;

export const CountrySection = styled.div`
  display: flex;
  max-width: 300px;
  width: 100%;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
`;

export const CallRatePrice = styled.div<{ $alignStart?: boolean }>`
  color: ${({ theme }) => theme.colors.default[400]};
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 550;
  display: flex;
  justify-content: ${({ $alignStart }) =>
    $alignStart ? "flex-start" : "center"};
  align-items: center;
`;
